import { render, staticRenderFns } from "./dr-text-field-spilka-ui-kit.vue?vue&type=template&id=5930131a"
import script from "./dr-text-field-spilka-ui-kit.vue?vue&type=script&lang=js"
export * from "./dr-text-field-spilka-ui-kit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports